// extracted by mini-css-extract-plugin
export default {"container":"Projects_container__Iy6Vg","title":"Projects_title__f1RE0","projects":"Projects_projects__0HGLx"};